export default __webpack_public_path__ + "static/bodywork2-e8bebadc2bac78168c30ec51679d8d70.jpeg";